import WhyCulinaria from '../views/pages/why-culinaria'
import Favorite from '../views/pages/favorite'
import Detail from '../views/pages/detail'

const Routes = {
  '/': WhyCulinaria, // default page
  '/favorite': Favorite,
  '/detail/:id': Detail
}

export default Routes
